import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';

// CORREÇÃO: Importa o interceptor correto que lida com a autenticação
import { AuthInterceptor } from './app/core/interceptors/auth.interceptors';
import { isDevMode, provideZonelessChangeDetection } from '@angular/core';
import { provideServiceWorker } from '@angular/service-worker';

// Importar serviços PWA
import { PwaService } from './app/core/pwa/services/pwa.service';
import { PwaTriggerService } from './app/core/pwa/services/pwa-trigger.service';
import { PwaDemoService } from './app/core/pwa/services/pwa-demo.service';

bootstrapApplication(AppComponent, {
    providers: [
        provideZonelessChangeDetection(),
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        provideIonicAngular(),
        provideRouter(routes, withPreloading(PreloadAllModules)),
        provideHttpClient(withXhr(), withInterceptorsFromDi()),

        // Configuração do Service Worker para PWA
        provideServiceWorker('ngsw-worker.js', {
          enabled: !isDevMode(),
          registrationStrategy: 'registerWhenStable:5000'
        }),

        // Configuração do Interceptor de Autenticação
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },

        // Serviços PWA
        PwaService,
        PwaTriggerService,
        PwaDemoService
    ],
});
